import { render, staticRenderFns } from "./VisibilityForm.vue?vue&type=template&id=27907fb4&scoped=true&"
import script from "./VisibilityForm.vue?vue&type=script&lang=js&"
export * from "./VisibilityForm.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/forms.css?vue&type=style&index=0&id=27907fb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27907fb4",
  null
  
)

export default component.exports